import React from 'react';
import { ConfigProvider } from 'antd';

interface Props {
  children: React.ReactNode;
}

export const WhiteLabelConfigProvider = ({ children }: Props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 8,
          colorBorder: 'var(--wl-border, #dfe1e3)',
          colorPrimary: 'var(--wl-primary-color, #FD5B2C)',
          colorBorderSecondary: 'var(--wl-border, #dfe1e3)',
          colorPrimaryBorder: 'var(--wl-border, #dfe1e3)',
          colorPrimaryBorderHover: 'var(--wl-border, #dfe1e3)',
          colorPrimaryHover: 'var(--wl-border, #dfe1e3)',
          controlOutline: 'var(--wl-border, #dfe1e3)',
          colorBgBase: 'var(--wl-background-light, #ffffff)',
          colorBgContainer: 'var(--wl-background-light, #ffffff)',
          colorBgLayout: 'var(--wl-background-light, #ffffff)',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
